"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useStateIfMounted", {
  enumerable: true,
  get: function get() {
    return _useStateIfMounted["default"];
  }
});

var _useStateIfMounted = _interopRequireDefault(require("./useStateIfMounted"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }